import { inject } from 'tsyringe'
import { containerScoped } from '~/decorators/dependency-container'
import RequestBuilder from '~/builders/http/RequestBuilder'
import {
  CartCost,
  CartSeller,
  CartShippingTypeType
} from '~/models/marketplace/cart'
import { Order } from '~/models/marketplace/order'

@containerScoped()
export default class MarketplaceCartService {
  constructor(@inject(RequestBuilder) private requestBuilder: RequestBuilder) {}

  getCart(): Promise<{ cost: CartCost; sellers: CartSeller[] }> {
    return this.requestBuilder.request('get', '/api/market/cart/').send()
  }

  removeCartItem(productId: number): Promise<{ message: string }> {
    return this.requestBuilder
      .request('delete', `/api/market/cart/items/${productId}/`)
      .action()
      .send()
  }

  addCartItem({
    productId,
    quantity
  }: {
    productId: number
    quantity: number
  }): Promise<{ message: string }> {
    return this.requestBuilder
      .request('post', `/api/market/cart/items/${productId}/`)
      .data({ quantity })
      .action()
      .send()
  }

  getCheckoutDetails(
    userId: number | string
  ): Promise<{ cartForSeller: CartSeller }> {
    return this.requestBuilder
      .request('get', `/api/market/cart/checkout/${userId}/`)
      .send()
  }

  checkoutCartForSeller({
    userId,
    shippingType,
    invoiceInfoId,
    shippingAddressId,
    savePaymentInfo
  }: {
    userId: number | string
    shippingType: CartShippingTypeType
    invoiceInfoId: number | null
    shippingAddressId: number
    savePaymentInfo: boolean
  }): Promise<{ message: string; order: Order }> {
    return this.requestBuilder
      .request('post', `/api/market/cart/checkout/${userId}/`)
      .data({
        shipping_type: shippingType,
        invoicing_info: invoiceInfoId,
        shipping_address: shippingAddressId,
        save_payment_info: savePaymentInfo
      })
      .send()
  }
}
